import XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {getStrYMDHMSS} from './dateUtils';
import {api} from '@/api';

/**
 * writeExcel 을 사용하면서 타입이 모두 애니로 되어있어 파악이 어려움
 * @param jsonDataArray 그리드 컬럼에서 data 에 index 값을 넣어준 배열이어야함. -> 보통 api 응답값을 바로 넘기는데.. 이 때, {index: number} 를 추가로 맵핑해야 정상적으로 작동함
 * @param keyMapJson 그리드 gridOptions.columns 넘겨줄 때 컬럼의 name 과 value 를 맵핑해 넣어주는 객체
 * @param fileName
 * @param formatter 그리드 gridOptions.columns 넘겨줄 때 formatter 형식과 동일
 */
export function writeExcel(jsonDataArray: any, keyMapJson: any, fileName: any, formatter: any): void {
  writeExcelFile(jsonDataArray, keyMapJson, fileName, formatter, true);
}

export function writeExcelFile(jsonDataArray: any, keyMapJson: any, fileName: any, formatter: any, download: any): any {
  var colCnt = 0;
  var rowCnt = jsonDataArray.length;
  var ws: any = {};
  // header
  Object.keys(keyMapJson).forEach((key: any): void => {
    let cellRef = XLSX.utils.encode_cell({c: colCnt, r: 0});
    let cell = {v: keyMapJson[key], t: 's'};
    ws[cellRef] = cell;

    colCnt++;
  });
  for (let i = 0; i < jsonDataArray.length; i++) {
    let jsonData = jsonDataArray[i];
    let currentCol = 0;
    Object.keys(keyMapJson).forEach((key: any): void => {
      var cellValue = jsonData[key] == null ? '' : jsonData[key];
      if (!cellValue === true) {
        const splitKeys = key.split('.');
        for (let j = 0; j < splitKeys.length; j++) {
          cellValue = j === 0 ? jsonData[splitKeys[j]] : cellValue[splitKeys[j]];
          if (!cellValue === true) {
            break;
          }
        }
      }
      var currentRow = i + 1; // 1행 헤띔 +1
      var cellRef = XLSX.utils.encode_cell({c: currentCol, r: currentRow});
      if (formatter && formatter[key] != null) {
        let cell = {row: jsonData, value: cellValue};
        cellValue = formatter[key](cell);
      }

      var cell = _getCell(cellValue);
      if (cell != null) {
        ws[cellRef] = cell;
      }

      currentCol++;
    });
  }

  const range = {s: {c: 0, r: 0}, e: {c: colCnt, r: rowCnt}};
  ws['!ref'] = XLSX.utils.encode_range(range);
  let workbook = {
    SheetNames: ['Sheet1'],
    Sheets: {Sheet1: ws}
  };

  const wbout = XLSX.write(workbook, {bookType: 'xlsx', bookSST: false, type: 'binary'});
  var blob = new Blob([_strToArrayBuffer(wbout)], {type: 'application/octet-stream'});

  if (download) {
    saveAs(blob, fileName + '.xlsx');
  } else {
    return blob;
  }
}

export function writeExcelFromArray(data: any[], fileName: any): any {
  var ws: any = {};

  for (var row = 0; row < data.length; row++) {
    if (Array.isArray(data[row])) {
      for (var col = 0; col < data[row].length; col++) {
        var cellRef = XLSX.utils.encode_cell({c: col, r: row});
        var cell = _getCell(data[row][col]);
        if (cell != null) {
          ws[cellRef] = cell;
        }
      }
    } else {
      var cellRef = XLSX.utils.encode_cell({c: 0, r: row});
      var cell = _getCell(data[row]);
      if (cell != null) {
        ws[cellRef] = cell;
      }
    }
  }

  var rowCnt = data.length;
  var colCnt = Array.isArray(data[row]) ? data[0].length : 1;

  const range = {s: {c: 0, r: 0}, e: {c: colCnt, r: rowCnt}};
  ws['!ref'] = XLSX.utils.encode_range(range);

  let workbook = {
    SheetNames: ['Sheet1'],
    Sheets: {Sheet1: ws}
  };

  var wbout = XLSX.write(workbook, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  });
  saveAs(
    new Blob([_strToArrayBuffer(wbout)], {
      type: 'application/octet-stream'
    }),
    fileName + '.xlsx'
  );
}

function _getCell(value: any): any {
  var cell: any = {v: value};
  if (cell.v == null) {
    return null;
  }

  if (typeof cell.v === 'number') {
    cell.t = 'n';
  } else if (typeof cell.v === 'boolean') {
    cell.t = 'b';
  } else if (cell.v instanceof Date) {
    cell.t = 's';
    cell.v = getStrYMDHMSS(cell.v);
  } else {
    cell.t = 's';
  }

  return cell;
}

function _strToArrayBuffer(str: any): any {
  var buf = new ArrayBuffer(str.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != str.length; ++i) view[i] = str.charCodeAt(i) & 0xff;
  return buf;
}

export function callbackAfterToJson(fileId: any, keyMapJson: any, callback: any): any {
  if (typeof FileReader === 'undefined') {
    var ExcelError: any = function(): any {};
    ExcelError.name = 'FileReader Not Found Exception';
    ExcelError.message = '브라우저 다른 거 사용해주세요.. ㅜㅜ';
    ExcelError.prototype = new Error();
    return new ExcelError();
  }

  var fileObj = typeof fileId === 'object' ? fileId : $(`#${fileId}`);
  if (fileObj == null || fileObj.length == 0) {
    throw new Error('\'fileId\'를 잘 넣으라구 친구!');
  }

  if (fileObj[0].files.length == 0) {
    throw new Error('파일선택이 완료되었을 경우에만 호출하라구 친구!');
  }

  var file = fileObj[0].files[0];

  var isUsableReadAsBinaryString = typeof FileReader.prototype.readAsBinaryString !== 'undefined';
  // var isUsableWorker: any = typeof Worker !== 'undefined';

  var reader = new FileReader();

  reader.onload = function(e: any): any {
    var data = e.target.result;
    var workbook;
    if (isUsableReadAsBinaryString) {
      workbook = XLSX.read(data, {type: 'binary'});
    } else {
      var str = _arrayBufferToStr(data);
      workbook = XLSX.read(btoa(str), {type: 'base64'});
    }
    _processWorkbook(workbook, keyMapJson, callback);
  };

  if (isUsableReadAsBinaryString) {
    reader.readAsBinaryString(file);
  } else {
    reader.readAsArrayBuffer(file);
  }
}

export function readExcelFile(file: File, keyMapJson: {[key: string]: any}, callBack: any): any {
  try {
    const reverseKeyMapJson = _reverseKeyMapJson(keyMapJson);
    var isUsableReadAsBinaryString = typeof FileReader.prototype.readAsBinaryString !== 'undefined';
    const reader = new FileReader();
    reader.onload = (e): any => {
      var data = (e.target as FileReader).result;
      var workbook;
      if (isUsableReadAsBinaryString) {
        workbook = XLSX.read(data, {type: 'binary'});
      } else {
        var str = _arrayBufferToStr(data as ArrayBuffer);
        workbook = XLSX.read(btoa(str), {type: 'base64'});
      }
      _processWorkbook(workbook, reverseKeyMapJson, callBack);
    };
    if (isUsableReadAsBinaryString) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  } catch (e) {
  }
}
function _arrayBufferToStr(data: ArrayBuffer): any {
  var o = '',
    l = 0,
    w = 10240;
  for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w, l * w + w)) as any);
  o += String.fromCharCode.apply(null, new Uint16Array(data.slice(l * w)) as any);

  return o;
}
function _processWorkbook(workbook: any, keyMapJson: any, callback: any): any {
  var firstSheetName = workbook.SheetNames[0];
  var rowObjectArray = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName]);
  var json = JSON.stringify(rowObjectArray);
  json = json.replace(/"\s+|\s+"/gi, '"');
  $.each(keyMapJson, function(key, value): any {
    json = json.replace(new RegExp('"' + (key as string) + '"', 'g'), '"' + value + '"');
  });

  callback(JSON.parse(json));
}
function _reverseKeyMapJson(json: any): any {
  const reverseJson: any = {};
  $.each(json, (k, v): any => {
    reverseJson[v] = k;
  });

  return reverseJson;
}

export async function getStorageByName(fileName: string, showName?: string, container: string = 'ncp'): Promise<any> {
  let request: any = {
    params: {
      fileName: decodeURI(fileName)
    },
    responseType: 'blob'
  };
  if (container) {
    request.params.container = container;
  }

  let response = await api.getStorage(request);
  const myBlob = new Blob([response.data], {type: 'application/octet-stream'});
  const qrUrl = window.URL.createObjectURL(myBlob);
  const a = document.createElement('a');
  const event = new MouseEvent('click');
  a.download = showName || fileName;
  a.href = qrUrl;
  a.dispatchEvent(event);
  window.URL.revokeObjectURL(qrUrl);
}
